import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import Layout from '../components/Layout.jsx';
import { api, getUser } from '../api.js';

export default function AdminTenants() {
  const me = getUser();
  if (me?.rol !== 'admin') return <Navigate to="/" replace />;

  const [form, setForm] = useState({ nombre: '', nit: '', tipo_negocio: 'motel', ciudad: '', admin_pin: '' });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [created, setCreated] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (form.admin_pin.length < 4) { setMsg('PIN debe tener al menos 4 dígitos.'); return; }
    setLoading(true);
    setMsg('');
    try {
      const r = await api.crearTenant(form);
      setCreated(r);
      setMsg('✓ Empresa creada.');
      setForm({ nombre: '', nit: '', tipo_negocio: 'motel', ciudad: '', admin_pin: '' });
    } catch (err) {
      setMsg('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="mb-8">
        <p className="eyebrow mb-2">Administración</p>
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Empresas (tenants)</h1>
        <p className="text-muted mt-3 max-w-xl">Cada empresa que asesoras es un tenant aislado. Crea una nueva cuando empieces a llevar la contabilidad de otro negocio.</p>
      </div>

      {created && (
        <div className="card-lime mb-6">
          <p className="eyebrow mb-2">Empresa lista</p>
          <h2 className="text-2xl font-bold tracking-tight mb-3">Nuevo tenant ID: {created.tenant_id}</h2>
          <p className="text-sm text-ink/80 mb-2">Cierra sesión y vuelve a entrar con:</p>
          <div className="font-mono text-sm space-y-1">
            <div>Empresa: <span className="font-bold">{created.tenant_id}</span></div>
            <div>Usuario: <span className="font-bold">{me.nombre}</span></div>
            <div>PIN: <span className="font-bold">el que acabas de poner</span></div>
          </div>
        </div>
      )}

      <form onSubmit={submit} className="card max-w-xl space-y-4">
        <p className="eyebrow">Nueva empresa</p>
        <div>
          <label className="label">Nombre comercial</label>
          <input className="input" value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} placeholder="Ej. Restaurante La Casona" required />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="label">NIT (opcional)</label>
            <input className="input" value={form.nit} onChange={(e) => setForm({ ...form, nit: e.target.value })} />
          </div>
          <div>
            <label className="label">Ciudad</label>
            <input className="input" value={form.ciudad} onChange={(e) => setForm({ ...form, ciudad: e.target.value })} placeholder="Cali" />
          </div>
        </div>
        <div>
          <label className="label">Tipo</label>
          <select className="input" value={form.tipo_negocio} onChange={(e) => setForm({ ...form, tipo_negocio: e.target.value })}>
            <option value="motel">Motel</option>
            <option value="hotel">Hotel</option>
            <option value="restaurante">Restaurante</option>
            <option value="tienda">Tienda</option>
            <option value="otro">Otro</option>
          </select>
        </div>
        <div>
          <label className="label">Tu PIN para esta empresa nueva</label>
          <input className="input text-center text-xl tracking-widest" type="password" inputMode="numeric" minLength={4} maxLength={8} value={form.admin_pin} onChange={(e) => setForm({ ...form, admin_pin: e.target.value })} required />
          <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-muted mt-2">Te crea un usuario con tu mismo nombre y este PIN para entrar a esa empresa.</p>
        </div>
        {msg && (
          <div className={`rounded-2xl px-3 py-2 text-sm font-mono ${msg.startsWith('✓') ? 'bg-lime/30 text-ink' : 'bg-red-50 text-red-800 border border-red-200'}`}>{msg}</div>
        )}
        <button className="btn-primary w-full" disabled={loading}>{loading ? 'Creando…' : 'Crear empresa'}</button>
      </form>
    </Layout>
  );
}
